module.exports = __webpack_public_path__ + "img/one.5b8944e0.png";